import type { DirectiveBinding } from 'vue';

/**
 * Нормализует значение v-tooltip так, чтобы по умолчанию был eager: false.
 * У VTooltip в Vuetify 4 в props overlay — eager: true; defaults из createVuetify
 * на экземпляры, создаваемые директивой со строковым значением, не подмешиваются.
 */
export function normalizeVTooltipBinding(
    binding: DirectiveBinding,
): DirectiveBinding {
    const v = binding.value;
    if (v === false || v === null || v === '') {
        return binding;
    }
    if (typeof v === 'boolean') {
        return binding;
    }
    if (typeof v === 'object' && v !== null && !Array.isArray(v)) {
        return {
            ...binding,
            value: { eager: false, ...v },
        };
    }
    return {
        ...binding,
        value: { text: String(v), eager: false },
    };
}
